

























import Vue from 'vue';
import Component from 'vue-class-component';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
const QuestionRepository = RepositoryFactory.get('question');

@Component
export default class Base extends Vue {
  // 回答日
  answer_date = '';
  // 回答がすべて完了したかどうかを判定
  is_complete = false;
  // 質問リスト
  inquiries = [];
  // 回答に移る
  next(inquiry: any): void {
    this.$router.push('/inquiry/' + inquiry.code + '/' + 1);
  }
  // Loadingの表示，非表示の制御
  toggleLoading(params: { is_loading: boolean; time: number }): void {
    this.$emit('toggleLoading', params);
  }
  async mounted(): Promise<any> {
    this.toggleLoading({ is_loading: true, time: 0 });
    const user = await this.$store.state.user;
    const response = await QuestionRepository.question();
    if (!response) {
      this.$toasted.error('ネットワークに問題があります', {
        duration: 2000,
        position: 'top-center'
      });
      this.toggleLoading({ is_loading: false, time: 0 });
    } else if ('timeout' in response && response.timeout == true) {
      this.$toasted.error('タイムアウトが発生しました', {
        duration: 2000,
        position: 'top-center'
      });
      this.toggleLoading({ is_loading: false, time: 0 });
    } else if (response.status == 200 && response.data.status == 'success') {
      this.inquiries = response.data.list;
      await this.$store.commit('question/setQuestions', response.data.list);
    } else if (response.status == 500) {
      this.$toasted.error('処理に失敗しました', {
        duration: 2000,
        position: 'top-center'
      });
      this.toggleLoading({ is_loading: false, time: 0 });
    }
    const date = new Date();
    this.answer_date =
      date.getFullYear() +
      '年' +
      (date.getMonth() + 1) +
      '月' +
      date.getDate() +
      '日';
    window.scrollTo(0, 0);
    this.toggleLoading({ is_loading: false, time: 0.5 });
  }
}
